export const standardFilterFields = [
	'clientId',
	'organizationId',
	'countryCode',
	'featureFlag',
] as const;

export const filterFields = [...standardFilterFields] as const;

export const adminStandardFilterFields = [...standardFilterFields] as const;

// oxlint-disable-next-line no-unused-vars
type _AdminFilterFieldsSafetyNet<
	T extends (typeof standardFilterFields)[number] = (typeof adminStandardFilterFields)[number],
> = T;

export const listStandardFilterFields = [...standardFilterFields] as const;

// oxlint-disable-next-line no-unused-vars
type _ListFilterFieldsSafetyNet<
	T extends (typeof filterFields)[number] = (typeof listStandardFilterFields)[number],
> = T;
